import {Setting} from "./Setting";

export const charactersSetting: Setting = {
    key: "Character",
    title: "Персонажи",
    description: "Персонажи — это главные, второстепенные и фоновые действующие лица игрового мира. Они определяют развитие сюжета, взаимодействуют с окружающей средой и влияют на атмосферу. Их характер, мотивация, внешний вид и образ жизни должны быть логично вписаны в сеттинг.",
    components: [
        {
            title: "Типы персонажей",
            subComponents: [
                {
                    title: "Главные герои",
                    description: "Персонажи, вокруг которых строится сюжет, чьи действия влияют на мир.",
                    examples: ["Воин, отправившийся в путешествие, чтобы отомстить за свой народ."]
                },
                {
                    title: "Антагонисты",
                    description: "Главные противники героя или силы, создающие конфликты.",
                    examples: ["Тиран, использующий магию крови, чтобы подчинить мир."]
                },
                {
                    title: "Второстепенные персонажи",
                    description: "Союзники, наставники, торговцы и другие персонажи, оказывающие влияние на историю.",
                    examples: ["Знахарь, знающий тайные рецепты эликсиров."]
                },
                {
                    title: "Фоновые персонажи",
                    description: "Жители мира, создающие ощущение реалистичной среды.",
                    examples: ["Ремесленники, работающие на площади."]
                },
                {
                    title: "Легендарные фигуры",
                    description: "Исторические личности, оставившие след в истории мира.",
                    examples: ["Герой древних времен, победивший чудовище."]
                }
            ]
        },
        {
            title: "Взаимодействие персонажей",
            subComponents: [
                {
                    title: "Отношения между персонажами",
                    description: "Дружба, вражда, любовь, предательства и другие аспекты взаимодействия.",
                    examples: ["Рыцарь и волшебница, объединенные общей целью, но ненавидящие друг друга."]
                },
                {
                    title: "Система авторитетов",
                    description: "Какие персонажи являются лидерами, какими качествами они обладают?",
                    examples: ["Вождь племени, чей авторитет основан на силе и мудрости."]
                },
                {
                    title: "Динамика групп",
                    description: "Как персонажи ведут себя в коллективе? Кто командует, кто подчиняется?",
                    examples: ["Отряд наемников, где каждый имеет свою специализацию."]
                },
                {
                    title: "Предательство и верность",
                    description: "Кто готов пойти на жертвы ради других? Кто легко предает?",
                    examples: ["Соратник, который переходит на сторону врага ради спасения своей семьи."]
                }
            ]
        }
    ],
    prompt: {
        component: {
            list: 'Перечисли возможные компоненты персонажей и опиши их',
            single: 'Cгенерируй компонент персонажа для мира. Опиши ключевые аспекты, характеристики и влияние на историю',
            extend: 'Дополни описание компонента персонажа и разбей на абзацы. Как он влияет на мир и других персонажей?'
        },
        element: {
            list: 'Перечисли возможные элементы компонента персонажей и опиши их. Укажи имена персонажей',
            single: 'Сгенерируй элемент персонажа для мира. Опиши ключевые аспекты, характеристики и влияние на историю. Укажи имя персонажа',
            extend: 'Дополни элемент персонажа подробностями и разбей на абзацы. Его внешность, взаимоотношения, как он влияет на мир и других персонажей?'
        },
        lore: {
            list: "Создай элементы лора на основе этого персонажа. Обязательно должны быть, биография, внешность, характер, конфликт, истории влияние на мир и на других персонажей персонажей",
            single: "Создай элементы лора на основе этого персонажа. Опиши что-то одно, например: биографию, внешность, характер, конфликт, историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора персонажа и разбей на абзацы."
        }
    }
}
